import React, { ReactNode } from 'react';
import Portal from '../portal/portal';
import { IcoClose } from '../icon/icon';
import { Button } from '../button/button';
import { useSelector } from 'react-redux';



export const Modal = ({
  name='modal',
  title,
  children,
  open = false,
  close,
  closeText = 'Fechar',
  size = 'medium',
  actions,
  cy
}) => {
  const {heigthPage} = useSelector(state=> state.layoutState)
  const heigthModal = { maxHeight: heigthPage.content ? `calc(${heigthPage.content}px)` : '100vh' }
  if (!Array.isArray(children)) {
    children = [children];
  }
  return (
    <Portal name={`modal-${name}`}>
      {open
        ? size === 'fullscreen'
          ? fullscreen({ title, open, children, size, closeText, close, actions, cy, heigthModal })
          : modalNormal({ title, open, children, size, closeText, close, actions, cy, heigthModal })
        : null}
    </Portal>
  );
};

const fullscreen = ({ title, children, closeText, close, actions, cy, heigthModal }) => {
  return (
    <div data-cy={cy} className={`box-modal fullScreen`} style={heigthModal}>
      <div className="modal-header">
        {title}
        {actions ? (
          <div className="modal-actions">
            <Button className="btn secondary normal" onClick={close}>
              {closeText}
            </Button>
            {actions}
          </div>
        ) : null}
      </div>
      <div className="modal-content">{children}</div>
    </div>
  );
};

const modalNormal = ({
  title,
  children,
  size,
  closeText,
  close,
  actions,
  cy,
  heigthModal
}) => {
  return (
    <div data-cy={cy} className={`box-modal`} style={heigthModal}>
      <div className={`size-${size}`}>
        <div className="modal-header">
          {title}
          {close?
            <Button className="modal-close" onClick={close} title={closeText}>
              <IcoClose />
            </Button>
          :null}
        </div>
        <div className="modal-content">{children}</div>
        {actions ? (
          <div className="modal-actions">
            {/* <Button color="secondary" variant="outline" onClick={close}>
              {closeText}
            </Button> */}
            {actions}
          </div>
        ) : null}
      </div>
    </div>
  );
};
